import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConWorks: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConWorkMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConWorksRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConWorks", null);
            } else {
                dispatch("receivingWebConWorks"); // สถานะ กำลังบันทึก


                // axios.get('/web_con_works').then(res => {
                //
                //     dispatch("receiveWebConWorks", res.data);
                // })


                // const formData = new FormData();
                // formData.append('work_type', payload.work_type);
                // formData.append('work_type_detail', payload.work_type_detail);
                // formData.append('status_check', payload.status_check);
                // formData.append('user_name', payload.user_name);

                axios.get('/web_con_works', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConWorks", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConWorks", null);
                    });

            }
        },
        loadWebConWorkRequest({dispatch}, id) {
            // We check if app runs with backend mode


            if (!config.isBackend) {
                dispatch("receiveWebConWork", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConWork");
                axios.get('/web_con_works/' + id).then(res => {
                    dispatch("receiveWebConWork", res.data);
                })
            }
        },
        updateWebConWorkRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConWork");
            const formData = new FormData();
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('work_id', payload.work_id);
            formData.append('user_name', payload.user_name);
            formData.append('work_type', payload.work_type);
            formData.append('work_type_detail', payload.work_type_detail);
            formData.append('work_public_inter', payload.work_public_inter);
            formData.append('work_public_type', payload.work_public_type);
            formData.append('work_public_base', payload.work_public_base);
            formData.append('work_owner_name_th', payload.work_owner_name_th);
            formData.append('work_owner_name_en', payload.work_owner_name_en);
            formData.append('work_title_th', payload.work_title_th);
            formData.append('work_title_en', payload.work_title_en);
            formData.append('work_public_title_th', payload.work_public_title_th);
            formData.append('work_public_title_en', payload.work_public_title_en);
            formData.append('work_weight', payload.work_weight);
            formData.append('work_public_year', payload.work_public_year);
            formData.append('work_public_no', payload.work_public_no);
            formData.append('work_public_number', payload.work_public_number);
            formData.append('work_public_isbn', payload.work_public_isbn);
            formData.append('work_public_date', payload.work_public_date);
            formData.append('work_public_month_year', payload.work_public_month_year);
            formData.append('work_public_place', payload.work_public_place);
            formData.append('work_public_province', payload.work_public_province);
            formData.append('work_public_country', payload.work_public_country);
            formData.append('status_link', payload.status_link);
            formData.append('work_h_file', payload.work_h_file);
            formData.append('work_h_url', payload.work_h_url);
            formData.append('status_check', payload.status_check);
            formData.append('active', payload.active);
            axios.post('/update_con_works', formData).then(res => {
                dispatch("updateWebConWork", res.data);
            })

        },
        createWebConWorkRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConWork");

            const formData = new FormData();
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('user_name', payload.user_name);
            formData.append('work_type', payload.work_type);
            formData.append('work_type_detail', payload.work_type_detail);
            formData.append('work_public_inter', payload.work_public_inter);
            formData.append('work_public_type', payload.work_public_type);
            formData.append('work_public_base', payload.work_public_base);
            formData.append('work_owner_name_th', payload.work_owner_name_th);
            formData.append('work_owner_name_en', payload.work_owner_name_en);
            formData.append('work_title_th', payload.work_title_th);
            formData.append('work_title_en', payload.work_title_en);
            formData.append('work_public_title_th', payload.work_public_title_th);
            formData.append('work_public_title_en', payload.work_public_title_en);
            formData.append('work_weight', payload.work_weight);
            formData.append('work_public_year', payload.work_public_year);
            formData.append('work_public_no', payload.work_public_no);
            formData.append('work_public_number', payload.work_public_number);
            formData.append('work_public_isbn', payload.work_public_isbn);
            formData.append('work_public_date', payload.work_public_date);
            formData.append('work_public_month_year', payload.work_public_month_year);
            formData.append('work_public_place', payload.work_public_place);
            formData.append('work_public_province', payload.work_public_province);
            formData.append('work_public_country', payload.work_public_country);
            formData.append('status_link', payload.status_link);
            formData.append('work_h_file', payload.work_h_file);
            formData.append('work_h_url', payload.work_h_url);
            formData.append('status_check', payload.status_check);
            formData.append('active', payload.active);
            axios.post('/web_con_works', formData).then(res => {
                dispatch("receiveWebConWork", res.data);

            })


        },
        deleteWebConWorkRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConWork", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConWork", payload);

            axios.post('/delete_con_works', payload).then(res => {
                dispatch("deleteWebConWork", {work_id: payload.work_id, res: res});
            })


        },
        receiveWebConWorks({commit}, payload) {
            commit("RECEIVED_CONWORKS", payload)
        },
        receivingWebConWorks({commit}) {
            commit("RECEIVING_CONWORKS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConWork({commit}, payload) {
            commit("RECEIVED_CONWORK", payload)
        },
        receivingWebConWork({commit}) {
            commit("RECEIVING_CONWORKS") //call matutions --> state.isReceiving = true;
        },
        updateWebConWork({commit}, payload) {
            commit("UPDATED_CONWORK", payload)
        },
        updatingWebConWork({commit}) {
            commit("UPDATING_CONWORK") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConWork({commit}, payload) {
            commit("DELETED_CONWORK", payload)
        },
        deletingWebConWork({commit}, payload) {
            commit("DELETING_CONWORK", payload)
        },
        afterDeleteWebConWork({commit}, payload) {
            commit("AFFTER_DELETED_CONWORK", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONWORKS(state, payload) {

            state.webConWorks = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONWORKS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONWORK(state, payload) {


            if (payload.work_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConWorkMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConWorkMessage: (state.webConWorkMessage == webConWorkMessage ? webConWorkMessage + ' ' : webConWorkMessage),

                });
            } else {
                let webConWorkMessage = 'บันทึกสำเร็จ! รายการ ' + payload.work_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConWorks: [...state.webConWorks, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConWorkMessage: (state.webConWorkMessage == webConWorkMessage ? webConWorkMessage + ' ' : webConWorkMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },

        UPDATED_CONWORK(state, payload) {
            console.log(payload)
            let index = state.webConWorks.findIndex(p => p.work_id === payload.work_id);
            let webConWorkMessage = 'บันทึกสำเร็จ! รายการ ' + payload.work_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConWorks: state.webConWorks.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConWorkMessage: (state.webConWorkMessage == webConWorkMessage ? webConWorkMessage + ' ' : webConWorkMessage),
            })
        },
        UPDATING_CONWORK(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONWORK(state, payload) {


            if (payload.work_id == undefined || payload.res.data.message == 'Relation') {
                let webConWorkMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.work_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConWorkMessage: (state.webConWorkMessage == webConWorkMessage ? webConWorkMessage + ' ' : webConWorkMessage),

                });
            } else {
                let indexToDelete = state.webConWorks.findIndex(p => p.work_id === payload.work_id);
                let webConWorks = [...state.webConWorks];
                webConWorks.splice(indexToDelete, 1);
                let webConWorkMessage = 'บันทึกสำเร็จ! รายการ ' + payload.work_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConWorks: [...webConWorks],
                    isDeleting: false,
                    idToDelete: null,
                    webConWorkMessage: (state.webConWorkMessage == webConWorkMessage ? webConWorkMessage + ' ' : webConWorkMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONWORK(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.work_id;
        },
        AFFTER_DELETED_CONWORK(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
